import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_serial_number",
                tableName: 'core_product_serial_number'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian tạo',
                width: 15,
                sortable: true,
                filter: { type: 'DateRange', match: 'custom'}
            },
            serial_number: { 
                name: 'serial_number', 
                type: "String", 
                label: 'Serial number',
                width: 14,
                sortable: true,
                filter: { type: 'input', match: 'contains'}
            },
            productionOrder: { 
                name: 'productionOrder', 
                type: "String", 
                label: 'Lệnh sản xuất',
                width: 14,
                sortable: true,
                class: 'padding-content',
                filter: { type: 'input', match: 'contains'},
                callback: true,
                computed: (data) => {
                    data.productionOrder = data.production_order_code + '<abbr class="external-link"><span class="pi pi-external-link"></span></abbr>';
                }
            },
            export_date: { 
                name: 'export_date', 
                type: "CustomDateTime", 
                label: 'Ngày sản xuất',
                width: 15,
                sortable: true,
                filter: { type: 'DateRange', match: 'custom'},
                computed: (data) => {
                    data.export_date = (data.production_order != undefined && data.production_order != null) ? data.production_order.manufacturing_date : ''
                }
            },
            model_code: { 
                name: 'model_code', 
                type: "String", 
                label: 'Model sản phẩm',
                width: 15,
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                computed: (data) => {
                    data.model_code = (data.product != undefined && data.product != null) ? data.product.model_code : ''
                }
            },
            model_name: { 
                name: 'model_name', 
                type: "String", 
                label: 'Tên sản phẩm',
                width: 15,
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                computed: (data) => {
                    data.model_name = (data.product != undefined && data.product != null) ? data.product.name : ''
                }
            },
            warrantyStatus: { 
                name: 'warrantyStatus', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label',
                width: 10,
                options: [{ value: 0, label: 'Chưa kích hoạt', style: 'color: #FF6600; font-weight: 500;'}, { value: 2, label: 'Chờ kích hoạt', style: 'color: #990099; font-weight: 500;'}, { value: 3, label: 'Đã kích hoạt', style: 'color: #00CC00; font-weight: 500;'}, { value: 4, label: 'Hết bảo hành', style: 'color: #0000CC;font-weight: 500;'}, { value: 6, label: 'Sản phẩm huỷ', style: 'color: #000;font-weight: 500;'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                sortable: true,
                computed: (data) => {
                    var warranty = -1;
                    if (data.product_serial_number_info != undefined && data.product_serial_number_info != null && Object.keys(data.product_serial_number_info).length) {
                        warranty = (data.product_serial_number_info.warranty_status != undefined && data.product_serial_number_info.warranty_status != null) ? Number(data.product_serial_number_info.warranty_status) : -1; 
                    }
                    if (warranty == -1) warranty = (data.warranty_status != undefined && data.warranty_status != null) ?  Number(data.warranty_status) : -1;
                    if (warranty != -1) {
                        data.warrantyStatus = (warranty == 5 ? 0 : warranty);
                    }
                    // data.warrantyStatus = warranty;
                }
            },
            product_id: {
                refs: ' production_order_code warranty_status product { model_code name} production_order { id manufacturing_date created_date status } product_serial_number_info { warranty_status status }',
                display: false
            }
        },)
    }

}